import OopsPage from './OopsPageContainer';

export default OopsPage;
